// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"B4-z"};